import * as Sentry from "@sentry/nextjs";

const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN;

Sentry.init({
  dsn: SENTRY_DSN || "https://760c9281aab74a3d80088a4fc83620a9@o912353.ingest.sentry.io/5849317",
  enabled: process.env.NODE_ENV === "production",
  tracesSampleRate: 1.0,
});
